import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { AppBar, IconButton, Toolbar, Collapse, Grid } from '@material-ui/core'
import { Link as Scroll } from 'react-scroll'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import logoBcie from '../../../assets/img/logoDash.webp'
// import NavButtonResponsive from '../../../components/navButtonResponsive/NavButtonResponsive'
import '../style/header.scss'
const NavButtonResponsive = React.lazy(() =>
  import('../../../components/navButtonResponsive/NavButtonResponsive'),
)

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontFamily: 'Nunito',
    backgroundImage: `url(${process.env.PUBLIC_URL + '/images/Piñas.webp'})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  appbar: {
    background: '#fff',
    boxShadow: '0 2px 4px 0 rgba(0,0,0,.2)',
  },
  appbarWrapper: {
    width: '80%',
    margin: '0 auto',
  },
  appbarTitle: {
    flexGrow: '1',
  },
  icon: {
    color: '#fff',
    fontSize: '2rem',
  },
  subTitle: {
    color: 'white',
    lineHeight: '45px',
    fontSize: '48px',
  },
  container: {
    textAlign: 'center',
  },
  title: {
    color: 'white',
    fontSize: '75px',
    fontWeight: 'bold',
    lineHeight: '80px',
  },
  goDown: {
    color: 'white',
    fontSize: '4rem',
  },
}))
export default function Header() {
  const classes = useStyles()
  const [checked, setChecked] = useState(false)
  useEffect(() => {
    setChecked(true)
  }, [])
  return (
    <div className={classes.root} id="header">
      <AppBar className={classes.appbar} elevation={0}>
        <Toolbar className={classes.appbarWrapper} id="appbarWrapper">
          <div className={classes.appbarTitle}>
            <img id="logoNavLanding" src={logoBcie} alt="React Logo" />
          </div>
          <NavButtonResponsive />
        </Toolbar>
      </AppBar>

      <Collapse
        in={checked}
        {...(checked ? { timeout: 1000 } : {})}
        collapsedHeight={50}
      >
        <Grid
          container
          xs={12}
          sm={12}
          md={12}
          className={classes.container}
          id="containerTitle"
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            style={{ background: '#4c3a2a4f' }}
          >
            <h2 className={classes.title}>Programa CAMBIO II</h2>
            <br />
            <h2 className={classes.subTitle}>
              Iniciativa de Inversiones Productivas para la Adaptación al Cambio
              Climático
            </h2>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Scroll to="place-to-visit" smooth={true}>
              <IconButton>
                <ExpandMoreIcon className={classes.goDown} />
              </IconButton>
            </Scroll>
          </Grid>
        </Grid>
      </Collapse>
    </div>
  )
}
